import { defaultTo } from 'lodash'
import {
  CaretakerDetailsDto,
  CaretakerDetailsView,
} from '$domain/model/caretaker/caretakerDetails/caretakerDetails.model'

const getMainQualification = (caretakerData: CaretakerDetailsDto) => {
  if (caretakerData.mainQualification) {
    return {
      qualificationName: defaultTo(caretakerData.mainQualification.qualificationName, ''),
      specialty: defaultTo(caretakerData.mainQualification.qualificationSpecialty, ''),
      type: defaultTo(caretakerData.mainQualification.qualificationType, ''),
      area: defaultTo(caretakerData.mainQualification.qualificationArea, ''),
    }
  }
  return {
    qualificationName: '',
    specialty: '',
    type: '',
    area: '',
  }
}

export const modelToCaretakerDetails = (cartakerData: CaretakerDetailsDto): CaretakerDetailsView => {
  return {
    name: defaultTo(cartakerData.name, ''),
    profilePicture: defaultTo(cartakerData.profilePicture, ''),
    mainQualification: getMainQualification(cartakerData),
    rating: defaultTo(Number(cartakerData.averageRating), 0),
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretakerDetails/caretakerDetails.mapper.ts